import { assetRequire } from "helpers/asset"

/*
 * Return evaluated webpack images based on the imageKey from a wizard component
 *
 * @param {string} pref - the wizard pref option name
 * @param {string} imageKey - the image key relevant to the pref
 * @param {string} noMatch - the mode to return when there's no match (retina or normal)
 * @param {string,object} A string for regular mode, object for retina
 */
export const imageLookup = (pref, imageKey, noMatch = "retina") => {
  const regNoMatch = require("images/icons/jewlr.gif")
  const retinaNoMatch = {
    x1: regNoMatch,
    x2: regNoMatch,
  }
  const noMatchOut = noMatch == "retina" ? retinaNoMatch : regNoMatch

  if (!imageKey) return noMatchOut

  const chainLookup = {
    x1: assetRequire(`images/product/ch/icons/1x/${imageKey}.png`),
    x2: assetRequire(`images/product/ch/icons/2x/${imageKey}.png`),
  }
  const engravingLookup = {
    x1: assetRequire(`images/product/ef/1x/${imageKey}.png`),
    x2: assetRequire(`images/product/ef/2x/${imageKey}.png`),
  }
  // image pathing for all prefs
  const lookups = {
    as: () => ({
      x1: assetRequire(`images/product/stones/40px/1x/side/${imageKey}.png`),
      x2: assetRequire(`images/product/stones/40px/2x/side/${imageKey}.png`),
    }),
    box: () => assetRequire(`images/product/photo_box/${imageKey}`),
    ch: () => chainLookup,
    ch2: () => chainLookup,
    chainLength: () => ({
      x1: assetRequire(`images/product/ch/length/1x/${imageKey}.png`),
      x2: assetRequire(`images/product/ch/length/2x/${imageKey}.png`),
    }),
    chainType: () => ({
      x1: assetRequire(`images/product/ch/type/1x/${imageKey}.png`),
      x2: assetRequire(`images/product/ch/type/2x/${imageKey}.png`),
    }),
    choice: () => assetRequire(`images/product/choice_thumbs/${imageKey}`),
    design: () =>
      assetRequire(`images/product/photo_box/box_designs/${imageKey}.png`),
    ef: () => engravingLookup,
    ef2: () => engravingLookup,
    j3d: () => require("images/product/icons/3d-v2.svg"),
    rw: () => require(`images/icons/ring-width-icons/${imageKey}.svg`),
    sc: () => assetRequire(`images/product/sc/stonecount_${imageKey}.svg`),
    sku: () => ({
      x1: assetRequire(`images/product/sku/1x/${imageKey}.png`),
      x2: assetRequire(`images/product/sku/2x/${imageKey}.png`),
    }),
    stone: () => ({
      x1: assetRequire(`images/product/stones/40px/1x/side/${imageKey}.png`),
      x2: assetRequire(`images/product/stones/40px/2x/side/${imageKey}.png`),
    }),
    sz: () => assetRequire(`images/product/sizes/ringsize_${imageKey}.svg`),
  }

  // return correct image
  if (typeof lookups[pref] !== "undefined") {
    return lookups[pref]() || noMatchOut
  } else if (/^s[0-9]+/.test(pref) || /^face[0-9]+_s[0-9]+$/.test(pref)) {
    return lookups.stone() || noMatchOut
  } else if (/m[0-9]+/.test(pref)) {
    return lookups.sku() || noMatchOut
  } else {
    return noMatchOut
  }
}
